module.exports = __webpack_public_path__ + "static/media/MF_Restaurant.6a05f703.jpg";